import { authSplitApi } from 'redux/helpers/slice.helpers';

export interface Release {
  version: string;
  date: string;
  type: string;
  highlights: string[];
  url: string;
}

export interface ReleasesInfo {
  latest: string;
  releases: Release[];
}

const RELEASES_URL = 'api/releases';

export const releasesApi = authSplitApi('releasesApi').injectEndpoints({
  endpoints: build => ({
    getCurrentRelease: build.query<Release, void>({
      query: () => `${RELEASES_URL}/current`,
    }),
    getReleases: build.query<ReleasesInfo, void>({
      query: () => RELEASES_URL,
    }),
    getReleaseNotes: build.query<string, string>({
      query: version => ({
        url: `${RELEASES_URL}/notes/${version}`,
        responseHandler: response => response.text(),
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCurrentReleaseQuery,
  useGetReleasesQuery,
  useLazyGetReleaseNotesQuery,
} = releasesApi;
